import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { reduxForm, change, formValueSelector } from 'redux-form';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { graphql } from 'react-apollo';
import { FETCH_ALL_FERTILIZERS } from 'api/activity';
import {
  BannerComponent,
  Button,
  Card,
  Checkbox,
  LevelNav,
  Modal,
} from 'common/components';
import { FertilizerForm } from 'containers';

class FertilizersForm extends PureComponent {
  state = {
    active: null,
    modal: false,
  };

  toggleModal = fertilizer => {
    const { changeValue, selectedFertilizers, onSubmit } = this.props;
    this.setState({ modal: !this.state.modal });

    // when fertlizer object reponse exists, update fertilizers form value
    if (fertilizer && fertilizer.name) {
      const fertilizers = (selectedFertilizers || []).concat([
        JSON.stringify(fertilizer),
      ]);
      changeValue('fertilizers', fertilizers);
      onSubmit();
    }
  };

  render() {
    const { onSubmit, fertilizers } = this.props;

    return (
      <Fragment>
        <BannerComponent
          theme={['static', 'strong', 'large', 'mobile-fixed']}
          message={
            <LevelNav
              nav={{
                left: {
                  label: <span className={'visible--desktop'}>Back</span>,
                  action: () => onSubmit(),
                },
                center: { label: 'Select Fertilizer' },
              }}
            />
          }
        />

        <form>
          {fertilizers && fertilizers.length === 0 && (
            <p className={'text--center text--medium'}>
              You have not added any fertilizers yet, please start by adding a
              fertilizer.
            </p>
          )}

          {fertilizers && fertilizers.length > 0 && (
            <Fragment>
              <p className={'text--fade'}>
                <small>Select a fertilizer from the list below to add.</small>
              </p>

              <div className={'field'}>
                {fertilizers && (
                  <Checkbox
                    name={'fertilizers'}
                    theme={['card']}
                    onChange={onSubmit}
                    options={fertilizers.map(fertilizer => {
                      const {
                        name,
                        nitrogen,
                        phosphorus,
                        potassium,
                        sulfur,
                        zinc,
                      } = fertilizer;
                      return {
                        value: JSON.stringify({ ...fertilizer }),
                        label: (
                          <Card
                            footer={`N ${nitrogen} : P ${phosphorus} : K ${potassium} : S ${sulfur} : Z ${zinc}`}
                          >
                            <h3 className={'cardlist__title'}>{name}</h3>
                          </Card>
                        ),
                      };
                    })}
                  />
                )}
              </div>
            </Fragment>
          )}
        </form>

        <Button
          className="btn btn--secondary btn--add"
          onClick={() => this.toggleModal()}
        >
          <span className={'visible--desktop'}>Add Fertilizer</span>
        </Button>

        {this.state.modal && (
          <Modal
            enableTopRightClose
            theme={['narrow']}
            onToggle={this.toggleModal}
          >
            <FertilizerForm closeForm={this.toggleModal} />
          </Modal>
        )}
      </Fragment>
    );
  }
}

FertilizersForm.propTypes = {
  // from redux form
  error: PropTypes.string,
  handleSubmit: PropTypes.func.isRequired,
  valid: PropTypes.bool.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  // from mapstat
  selectedFertilizers: PropTypes.array,
  // from dispatch
  changeValue: PropTypes.func.isRequired,

  // manually added
  onSubmit: PropTypes.func.isRequired,
  // graphql list
  fertilizers: PropTypes.arrayOf(PropTypes.object),
};

const formSettings = {
  form: 'activityform',
  destroyOnUnmount: false,
};
const field = formValueSelector(formSettings.form);
const mapState = state => ({
  selectedFertilizers: field(state, 'fertilizers'),
});
const mapDispatch = dispatch => ({
  changeValue: (fieldname, value) =>
    dispatch(change(formSettings.form, fieldname, value)),
});

export default compose(
  graphql(FETCH_ALL_FERTILIZERS, {
    options: () => ({
      fetchPolicy: 'cache-and-network',
    }),
    props: props => {
      const {
        data: { getAllFertilizers },
      } = props;
      return { fertilizers: getAllFertilizers, ...props };
    },
  }),
  reduxForm(formSettings),
  connect(
    mapState,
    mapDispatch
  )
)(FertilizersForm);



// WEBPACK FOOTER //
// ./src/containers/ActivityForm/forms/Fertilizers.js